import { Component, Input,EventEmitter ,Output} from "@angular/core";
import { userNotification } from "src/app/interfaces/notification.model";

// import { DomSanitizer } from "@angular/platform-browser";
// import {
//   NgbDropdown,
//   NgbDropdownMenu,
//   NgbDropdownToggle
// } from "@ng-bootstrap/ng-bootstrap";



@Component({
  selector: "notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"]
})
export class NotificationComponent {
  

  // Show dot on top of the icon
  @Input() userNotificationsList : userNotification [] = [];
  
  // Show dot on top of the icon
  @Input() dot: string;

  // Show pulse on icon
  @Input() pulse: boolean;

  @Input() pulseLight: boolean;

  // Set icon class name
  @Input() icon: string = "flaticon2-bell-alarm-symbol";
  @Input() iconType: "" | "success";

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  // Set bg image path
  @Input() bgImage: string;

  // Set skin color, default to light
  @Input() skin: "light" | "dark" = "light";

  @Input() type: "brand" | "success" = "success";
  @Output() scolled :EventEmitter<any> = new EventEmitter()
  @Output() readNotification:EventEmitter<number>=new EventEmitter()
  @Output() readAllNotification:EventEmitter<any>=new EventEmitter()
  /**
   * Component constructor
   *
   * @param sanitizer: DomSanitizer
   */
  constructor(
    // private sanitizer: DomSanitizer,
    ) {}

  backGroundStyle(): string {
    if (!this.bgImage) {
      return "none";
    }

    return "url(" + this.bgImage + ")";
  }
  onScroll(e) {
   /* if(this.boxes.length>=100) {
      console.log('No more items');
      return;
    }*/
    this.scolled.emit(e)
    console.log('scrolled!!', e);
   
   // this.userNotificationsList = [...this.userNotificationsList, ...this.userNotificationsList];
  }
  
   ReadNotification(id){
    this.readNotification.emit(id)
   }
   clearALL(){
    this.readAllNotification.emit()
   }
}
